<template>
	<div>
		<topTab ref="topTab" :tab-data="tabData" @tab-change="changePages">
			<el-form :inline="true" :model="formInline" class="user-search">
				<el-form-item label="所属门店：">
					<el-select v-model="formInline.storeKeyId" placeholder="请选择门店" clearable filterable size="small" @change="handleStoreChange">
						<el-option v-for="item in storeList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="顾客：">
					<el-select v-model="formInline.customerKeyId" placeholder="请选择顾客" clearable filterable size="small" @change="inputChange">
						<el-option v-for="item in customerList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="退款编号：">
					<el-input v-model="formInline.code" placeholder="请输入退款编号" clearable size="small"></el-input>
				</el-form-item>
				<el-form-item label="会员编号：">
					<el-input v-model="formInline.vipNo" placeholder="请输入会员编号" clearable size="small"></el-input>
				</el-form-item>
				<el-form-item label="日期：">
					<el-date-picker
						v-model="dateStr"
						type="daterange"
						value-format="yyyy-MM-dd"
						range-separator="至"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
						size="small"
						@change="handleDateChange"
					></el-date-picker>
				</el-form-item>
				<el-form-item>
					<el-button v-if="$checkBtnPermission('/vip/returnMoney', 'viewPage')" size="small" type="primary" class="el-icon-search" @click="inputChange()">搜索</el-button>
				</el-form-item>
			</el-form>
			<STable :columns="columnsData" :data="listData" :loading="loading" border stripe row-key="keyId"></STable>
			<!-- 分页组件 -->
			<Pagination v-if="pageShow" :child-msg="pageparm" @call-father="callFather"></Pagination>
		</topTab>
	</div>
</template>

<script>
import { GetVipReturnHistoryPageList } from "@/api/vipApi.js";
import { GetOrgInfoListByConfig } from "@/api/organizationalApi.js";
import { GetCustomerListByStore } from "@/api/baseDataApi.js";
export default {
	data() {
		return {
			activeTab: "1",
			tabData: [
				{
					key: "1",
					value: "收款记录"
				}
			],
			pageShow: true,
			loading: false, // 显示加载
			listData: [],
			selectionList: [],
			dateStr: [],
			// 分页参数
			pageparm: {
				pageIndex: 1,
				pageSize: 10,
				total: 0
			},
			formInline: {
				pageIndex: 1,
				pageSize: 10,
				storeKeyId: "",
				startTime: null,
				endTime: null,
				code: "",
				vipNo: "",
				customerKeyId: ""
			},
			storeList: [],
			userList: [],
			columnsData: [],
			listColumns: [
				{
					prop: "rowNumber",
					label: "序号",
					align: "center",
					width: "80",
					isKeep: true
				},
				{
					prop: "createTime",
					label: "经办时间",
					width: "170",
					align: "center",
				},
				{
					prop: "creator",
					label: "经办人",
					width: "120",
					align: "center",
				},
				{
					prop: "typeName",
					label: "退款类型",
					width: "100",
					align: "center"
				},
				{
					prop: "storeName",
					label: "门店名称",
					isKeep: true,
					width: "160",
					align: "center"
				},
				{
					prop: "vipInfo.vipNo",
					label: "会员号",
					width: "170",
					align: "center"
				},
				{
					prop: "customerInfo.name",
					label: "顾客名称",
					width: "170",
					align: "center"
				},
				{
					prop: "customerInfo.phone",
					label: "顾客手机号",
					width: "170",
					align: "center"
				},
				{
					prop: "returnMoney",
					label: "退款金额(元)",
					width: "120",
					align: "center",
					isMoney: true,
					moneyType: "expense"
				},
				{
					prop: "sourceMoney",
					label: "原金额(元)",
					width: "120",
					align: "center",
					isMoney: true,
					moneyType: "normal"
				},
				{
					prop: "bonusMoney",
					label: "原赠送金额(元)",
					width: "120",
					align: "center",
					isMoney: true,
					moneyType: "normal"
				},
				{
					prop: "content",
					label: "退款内容",
					minWidth: "300",
					align: "center"
				},
				{
					prop: "remark",
					label: "退款备注",
					minWidth: "160",
					align: "center"
				}
			],
			customerList: []
		};
	},
	// 注册组件
	components: {},
	created() {
		// 初始列
		this.getCheckBox(this.listColumns.map((item) => item.label));
		this.getListData();
		this.GetOrgInfoListByConfig();
	},
	computed: {},
	methods: {
		// 获取筛选框
		getCheckBox(val) {
			let arr = this.listColumns.filter((v) => !val.includes(v.label));
			this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
		},
		changePages() {},
		// 获取所属门店
		GetOrgInfoListByConfig() {
			const paramer = {
				key: 1
			};
			GetOrgInfoListByConfig(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.storeList = [];
						if (res.code == 1) {
							res.data.forEach((item) => {
								this.storeList.push({
									keyId: item.keyId,
									value: item.name + "【" + item.remark2 + "】"
								});
							});
						} else {
							this.$message.error(res.msg);
						}
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取门店信息失败!");
				});
		},
		// 获取列表
		getListData() {
			this.loading = true;
			var params = {
				...this.formInline,
				storeKeyId: this.formInline.storeKeyId || null,
				customerKeyId: this.formInline.customerKeyId || null
			};
			GetVipReturnHistoryPageList(params)
				.then((res) => {
					if (res.code == 1) {
						this.loading = false;
						this.listData = res.data;
						this.pageparm.total = res.totalNumber;
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("数据加载失败，请稍后再试！");
				});
		},
		inputChange(val) {
			this.search();
		},
		// 分页插件事件
		callFather(parm) {
			if (parm.currentPage == undefined) {
				this.formInline.pageIndex = 1;
			} else {
				this.formInline.pageIndex = parm.currentPage;
			}
			this.formInline.pageSize = parm.pageSize;
			this.getListData();
		},
		// 搜索事件
		search() {
			this.formInline.pageIndex = 1;
			this.pageShow = false;
			this.$nextTick(() => {
				this.pageShow = true;
			});
			this.getListData();
		},
		// 日期选择器事件
		handleDateChange(val) {
			if (val.length > 0) {
				this.formInline.startTime = val[0];
				this.formInline.endTime = val[1];
			} else {
				this.formInline.startTime = null;
				this.formInline.endTime = null;
			}
		},
		// 获取客户信息列表
		GetCustomerList(storeKeyId) {
			const paramer = {
				keyId: storeKeyId
			};
			GetCustomerListByStore(paramer)
				.then((res) => {
					this.customerList = [];
					if (res.code == 1) {
						this.customerList = res.data;
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取客户信息失败!");
				});
		},
		// 门店选择器事件
		handleStoreChange(val) {
			if (val.length > 0) {
				this.formInline.storeKeyId = val;
				this.GetCustomerList(val);
			} else {
				this.formInline.storeKeyId = "";
				this.customerList = [];
			}
		}
	}
};
</script>

<style scoped></style>
